<ndt-add-account-location-view
   [callState]="callState$ | async"
   [form]="form"
   [isEdit]="isEdit"
   (formCanceled)="onCancel()"
   (formSubmitted)="onSubmit($event)"
>
</ndt-add-account-location-view>
